module.exports = __webpack_public_path__ + "static/media/YF22_2.173740e2.jpg";